import React from "react";
import "../../styles/categories.css";

// 1. Import Lucide Icon for "All Categories"
import { LayoutGrid } from "lucide-react";

// 2. Import Images from Assets
import schoolImg from "../../assets/school.gif";
import indianImg from "../../assets/indian.gif";
import globalImg from "../../assets/globe.gif";
import commerceImg from "../../assets/commerce.gif";
import skillsImg from "../../assets/skill.gif";

const Categories = () => {
  const categoryList = [
    {
      id: 1,
      title: "All Categories",
      // Dark color icon settings
      icon: <LayoutGrid size={28} color="#333333" strokeWidth={2} />,
      active: true,
      link: "/", // Keeps user on the main page
    },
    {
      id: 2,
      title: "Tuition Program",
      img: schoolImg,
      // Link to the School Subdomain
      link: "https://tuition.madhiacademy.com/",
    },
    {
      id: 3,
      title: "Indian Professional",
      img: indianImg,
      // Link to the Professional Subdomain
      link: "https://pro.madhiacademy.com/",
    },
    {
      id: 4,
      title: "Global Professional",
      img: globalImg,
      // Link to the Global Subdomain
      link: "https://global.madhiacademy.com/",
    },
    {
      id: 5,
      title: "Commerce",
      img: commerceImg,
      // Add your Commerce specific link here
      link: "https://degree.madhiacademy.com/",
    },
    {
      id: 6,
      title: "Skills Training",
      img: skillsImg,
      // Add your Skills specific link here
      link: "https://skills.madhiacademy.com/",
    },
  ];

  return (
    <section className="categories-section container">
      <div className="categories-wrapper">
        {categoryList.map((item) => (
          // WRAPPER: Turns the whole card into a clickable link
          <a
            key={item.id}
            href={item.link}
            className="category-link"
            style={{ textDecoration: "none", color: "inherit" }} // Removes default blue underline
          >
            <div className="category-item">
              <div className={`icon-box ${item.active ? "active-box" : ""}`}>
                {/* Render Logic: Check if it's an Image path or an Icon component */}
                {item.img ? (
                  <img
                    src={item.img}
                    alt={item.title}
                    className="category-icon"
                  />
                ) : (
                  // Render the Lucide Icon
                  <span
                    className="category-icon-svg"
                    style={{ color: item.active ? "#fff" : "inherit" }}
                  >
                    {item.icon}
                  </span>
                )}
              </div>

              <h6
                className={`category-title ${item.active ? "active-text" : ""}`}
              >
                {item.title}
              </h6>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Categories;
